
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { ServiceReportsApi } from "./api";
import ServiceReportsGrid from "./ServiceReportsGrid";
import DownloadReportDialog from "../Events/DownloadReportDialog";

interface serviceReportsWidgetProps {
  id: string;
  header: string;
  machine?: string;
}

const GridWidget = (props: serviceReportsWidgetProps) => {
  const [serviceReports, updateServiceReports] = useState(null);
  const [serviceReportsLoading, updateLoadingServiceReports] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const globalParams = useSelector(getParamsSelector);
    const [dialogVisible, updateDialogVisible] = useState(false);
    const [ids, updateIds] = useState(null);


    const updateIdsHandler = (_ids: any) => {
        updateIds(_ids);
        toggleDialog();
    };
    const toggleDialog = () => {
        dialogVisible ? updateDialogVisible(false) : updateDialogVisible(true);
    };



  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (
      globalParams.customerID != null &&
      globalParams.mainMachineSerialNo == null
    ) {
      updateLoadingServiceReports(true);
      getServiceReports(globalParams.customerID, signal);
    } else if (globalParams.mainMachineSerialNo != null) {
      updateLoadingServiceReports(true);
      getMachineServiceReports(globalParams.mainMachineSerialNo, signal);
    }

    return () => controller.abort();
  }, [globalParams.customerID, globalParams.mainMachineSerialNo]);

  const getServiceReports = (cId, signal) => {
    let params: any = { customerId: cId };
    ServiceReportsApi.getCustomerServiceReports(params, signal)
      .then((response: any) => {
        updateServiceReports(response);
        updateLoadingServiceReports(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingServiceReports(true);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };
  const getMachineServiceReports = (machineSerial, signal) => {
    let params: any = { machineSerial: machineSerial };
    ServiceReportsApi.getMachineServiceReports(params, signal)
      .then((response: any) => {
        updateServiceReports(response);
        updateLoadingServiceReports(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingServiceReports(true);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };
  if (serviceReportsLoading) {
    return <Spinner text="service reports" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
    return (<> <ServiceReportsGrid data={serviceReports} updateIdsHandler={updateIdsHandler}  />
        <DownloadReportDialog
            visible={dialogVisible}
            toggleVisible={toggleDialog}
            ids={ids}
        />
    </>);
};

export default GridWidget;
